export default {
  init() {

    /** Go Up Button Start */

      $('button.go-up').on('click', function() {
        $('html, body').stop().animate({ scrollTop: 0 }, 500, 'swing');
      });

    /** Go Up Button End */

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/home.js